import { tagColors } from "@/components/tag/tag-colors";
export const shipmentBillOption = [
  {id: 'waitShipped', text: '待出运', ...tagColors.orange},
  { id: 'shipped', text: '已出运', ...tagColors.violet},
  { id: 'deliverying', text: '收货中', ...tagColors.blue},
  { id: 'completed', text: '已完成', ...tagColors.green},
  { id: 'abolished', text: '已作废', ...tagColors.lightGray},
];

export const shipmentBillEnum = {
  WAIT_SHIPPED: 'waitShipped',
  SHIPPED: 'shipped',
  DELIVERYING: 'deliverying',
  COMPLETED: 'completed',
  ABOLISHED: 'abolished',
};
